<template>
  <div>
    <b-button size="is-small" @click="modalFotos = true">Fotos</b-button>
    <b-modal :active.sync="modalFotos" has-modal-card trap-focus>
      <div class="modal-card">
        <b-carousel
          indicator-custom
          :indicator-inside="false"
          :animated="true"
          :autoplay="true"
          :pause-hover="true"
          :pause-info="false"
          :pause-text="''"
          :repeat="true"
        >
          <b-carousel-item v-for="(foto, i) in fotos" :key="i">
            <div class="image">
              <foto :entidade="entidade" :diario="diario" :all="all" :id="id" :name="foto.name"></foto>
            </div>
          </b-carousel-item>
          <template slot="indicators" slot-scope="props">
            <figure class="al image" :draggable="false">
              <foto :entidade="entidade" :diario="diario" :all="all" :id="id" :name="fotos[props.i].name"></foto>
            </figure>
          </template>
        </b-carousel>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalFotos: false,
      al: {
        hasGrayscale: true,
        itemsToShow: 2,
        breakpoints: {
          768: {
            hasGrayscale: false,
            itemsToShow: 4
          },
          960: {
            hasGrayscale: true,
            itemsToShow: 6
          }
        }
      }
    };
  },
  props: {
    id: {
      default: 0,
      type: Number
    },
    entidade: {
      default: 0,
      type: Number
    },
    fotos: {
      default: () => [],
      type: Array
    },
    all: {
      default: false,
      type: Boolean
    },
    diario: {
      default: false,
      type: Boolean
    }
  },
  components: {
    Foto: () => import("./Foto.vue")
  }
};
</script>

<style>
.is-active .al img {
  border: 1px solid #fff;
  filter: grayscale(0%);
}
.al img {
  border: 1px solid transparent;
  filter: grayscale(100%);
  max-width: 100px;
}
</style>